import React from 'react';
import WorkflowDecisionTabs from './WorkflowDecisionTabs';
import WorkflowLinkPicker from './WorkflowLinkPicker';

/** Carte éditable d'un nœud (le badge de la rangée est rendu par WorkflowStepList). */
export default function WorkflowStepEditor({ node, onChange, onRemove, depth, dragHandle }) {
  if (node.type === 'decision') {
    return <WorkflowDecisionTabs node={node} onChange={onChange} onRemove={onRemove} depth={depth} dragHandle={dragHandle} />;
  }

  return (
    <div className="wf-card">
      <div className="wf-card-head">
        <span className="wf-type action">Action</span>
        <input className="wf-edit-title" placeholder="Que faut-il faire ?" value={node.title || ''}
          onChange={(e) => onChange({ title: e.target.value })} />
        <button className="wf-grip" title="Glisser" aria-label="Réordonner" {...(dragHandle || {})}>⠿</button>
      </div>

      <div className="wf-meta-edit">
        <label className="wf-auto" title="Étape automatisable">
          <input type="checkbox" checked={!!node.automatable} onChange={(e) => onChange({ automatable: e.target.checked })} />
          {node.automatable ? '🤖 auto' : '✋ manuelle'}
        </label>
        <input value={node.responsible || ''} placeholder="responsable" onChange={(e) => onChange({ responsible: e.target.value })} />
        <input className="wf-min" type="number" min="0" value={node.estimated_minutes ?? ''} placeholder="min"
          onChange={(e) => onChange({ estimated_minutes: e.target.value === '' ? null : Math.max(0, parseInt(e.target.value, 10) || 0) })} />
        <WorkflowLinkPicker link={node.link} onChange={(link) => onChange({ link })} />
        <button className="btn-icon delete wf-card-del" title="Supprimer" onClick={onRemove}>🗑️</button>
      </div>

      <textarea className="wf-desc-input" placeholder="Note / détail (optionnel)" rows={1}
        value={node.description || ''} onChange={(e) => onChange({ description: e.target.value })} />

      <label className="wf-cond-edit">
        ✔️
        <input type="text" value={node.completion_condition || ''} placeholder="condition avant de terminer (optionnel)"
          onChange={(e) => onChange({ completion_condition: e.target.value })} />
      </label>
    </div>
  );
}
